import { render, staticRenderFns } from "./permata.vue?vue&type=template&id=2f068b2b&scoped=true"
import script from "./permata.vue?vue&type=script&lang=js"
export * from "./permata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f068b2b",
  null
  
)

export default component.exports